// extracted by mini-css-extract-plugin
export default {"oteviraciDoba":"OteviraciDoba_oteviraciDoba__6atfh"};